"use client";

import { GeneralNewWindow } from "@fanduel/formation-react-icons";
import { Button } from "@/components/formation";
import styles from "./playByPlay.module.scss";

type FollowButtonProps = {
  url: string;
};

const FollowButton = ({ url }: FollowButtonProps) => {
  const handleButtonClick = () => {
    window.open(url, "_blank", "noopener,noreferrer");
  };

  return (
    <Button
      as="a"
      variant="tertiary"
      size="regular"
      onClick={handleButtonClick}
      label="Follow on FanDuel Sportsbook"
      iconRight={<GeneralNewWindow />}
      className={styles.playByPlayButton}
    />
  );
};

export default FollowButton;
